import React, { ReactElement, CSSProperties, ReactNode } from "react";
import { FlexRow } from "../ui-kit/Layout/Flex";
import Card, { CardBody, CardHeader } from "./Card";
import Gutter from "../ui-kit/Gutter";
import { Typography } from "../ui-kit/Typography";

interface InsuranceInfoCardProps {
  title?: string;
  description?: string;
  children: ReactNode | ReactNode[];
  shadowStyle?: "small" | "medium" | "none";
  style?: CSSProperties;
  bodyStyle?: CSSProperties;
  headerStyle?: CSSProperties;
}
const InsuranceInfoCard = ({
  title,
  children,
  shadowStyle,
  style,
  bodyStyle,
  headerStyle,
}: InsuranceInfoCardProps): ReactElement => {
  return (
    <Card shadowStyle={shadowStyle} style={style}>
      {title && (
        <CardHeader style={{ alignItems: "stretch", ...headerStyle }}>
          <FlexRow alignItems="center" justifyContent="space-between">
            <Typography variant="h4" color="grey500">
              {title}
            </Typography>
            <div>
              <Typography></Typography>
            </div>
          </FlexRow>
        </CardHeader>
      )}
      <Gutter size={1} />
      <CardBody style={bodyStyle}>{children}</CardBody>
    </Card>
  );
};

InsuranceInfoCard.defaultProps = {
  shadowStyle: "medium",
  style: {},
};

export default InsuranceInfoCard;
